/* eslint react/prefer-stateless-function: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { matchPath } from 'react-router-dom';

import Home from './Home';
import { translate } from '../../locales/i18n';

class Search extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.getString = this.getString.bind(this);
    this.getTag = this.getTag.bind(this);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'Search';

    const string = this.getString(this.props);

    this.state = {
      string,
      searchResult: string,
      searchNotFound: false,
    };
  }

  componentDidMount() {
    const string = this.getString(this.props);

    console.log('Search: componentDidMount()');
    if (string && string !== '') {
      this.getTag(string);
    }
  }

  componentDidUpdate(prevProps, _prevState) {
    console.log('Search: componentDidUpdate()');
    const prevString = this.getString(prevProps);
    const string = this.getString(this.props);
    console.log(`${prevString} --> ${string}`);

    if (string !== prevString && string && string !== '') {
      this.getTag(string);
    }
  }

  getString(props) {
    const { location } = props;
    const match = matchPath('/ai-agents/:string', location.pathname);
    return match ? unescape(match.params.string) : '';
  }

  getTag(newString) {
    const { searchResult } = this.state;

    console.log('Search: getTag()');

    /* TODO: do search */

    // doSearch()
    //   .then((result) => {
    //     console.log('Search: getPTag() result');
    //     if (result) {
    //       this.setState({ searchResult: result, searchNotFound: false });
    //     } else {
    //       this.setState({ searchResult: undefined, searchNotFound: true });
    //     }
    //   });
    if (newString !== searchResult) {
      this.setState({ string: newString, searchResult: newString, searchNotFound: false });
    }
  }

  render() {
    const { searchResult, searchNotFound } = this.state;
    const {
      ...otherProps
    } = this.props;
    let { string } = this.state;

    const translated = translate(string);
    if (translated) {
      string = translated;
      console.log('translated');
    }

    console.log('string');
    console.log(string);
    console.log('searchResult');
    console.log(searchResult);

    return (
      <Home
        key={string}
        search={string}
        // searchInProgress={searchInProgress}
        searchInProgress={false}
        searchNotFound={searchNotFound}
        // searchName={searchName}
        searchName={searchResult}
        {...otherProps} // eslint-disable-line react/jsx-props-no-spreading
      />
    );
  }
}

Search.defaultProps = {
  user: undefined,
};

Search.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
  // history: ReactRouterPropTypes.history.isRequired,
  user: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  location: ReactRouterPropTypes.location.isRequired,
};

export default Search;
